import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'msToHms'
})
export class MsToHmsPipe implements PipeTransform {

    transform(value: number | string | undefined | null): string {
        if (value === undefined || value === null || value === '') {
            return '';
        }

        const ms = typeof value === 'string' ? parseInt(value, 10) : value;

        if (isNaN(ms)) {
            return '';
        }

        const totalSeconds = Math.floor(ms / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const h = hours.toString().padStart(2, '0');
        const m = minutes.toString().padStart(2, '0');
        const s = seconds.toString().padStart(2, '0');

        return `${h}:${m}:${s}`;
    }

}
